import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './styles/tailwind.css';
import { Toaster, toast } from 'react-hot-toast';
import ErrorBoundary from './components/ErrorBoundary';

window.onerror = function (message) {
  toast.error(`Ошибка: ${message}`);
};
window.onunhandledrejection = function (event) {
  toast.error(`Ошибка: ${event.reason}`);
};

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <ErrorBoundary>
    <Toaster position="top-right" />
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ErrorBoundary>,
);
